"use strict";

var PyDefUtils = require("PyDefUtils");
var utils = require("../utils");
const { isInvisibleComponent } = require("@runtime/components/helpers");

module.exports = function(pyModule) {

    pyModule["DesignRichText"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["__init__"] = PyDefUtils.funcFastCall(function([self], kws) {
            Sk.misceval.callsimArray(pyModule["RichText"].prototype["__init__"], [self], kws);
            self._anvil.placeholderElement || (self._anvil.placeholderElement = getPlaceholderElement());
            self._anvil.updateDesignName = updateDesignName;

            self._anvil.whereWillItLand = function(x, y, width, height, mouseX, mouseY) {
                let slots = self._anvil.slots;//element.find("span[x-anvil-slot]");

                let nearestEmptySlot = null;
                let minDistance = Number.MAX_VALUE
                for (let slot of Object.values(slots)) {
                    if (!slot.hasComponents)
                    {
                        let [dist, edge] = utils.distanceToEdge($(slot.domNode), mouseX, mouseY);
                        if (dist < minDistance) {
                            minDistance = dist;
                            nearestEmptySlot = slot.domNode;
                        }
                    }
                }

                if (nearestEmptySlot) {
                    return {
                        childIdx: self._anvil.components.length,
                        layoutProperties: { slot: $(nearestEmptySlot).attr("x-anvil-slot") },
                        estimatedPosition: utils.positionOf($(nearestEmptySlot)),
                    };
                } else {
                    return {
                        childIdx: self._anvil.components.length,
                        layoutProperties: {},
                        estimatedPosition: utils.bottomOf(self._anvil.element),
                    }
                }
            };

            self._anvil.setLayoutProperties = function(pyChild, props) {
                const $el = $(handle.pyChild.anvil$hooks.domElement);
                
                let slot;
                if ("slot" in props) {
                    slot = props['slot'];
                    for(let c of self._anvil.components) {
                        if (c.component === pyChild) {
                            c.layoutProperties.slot = slot;
                            break;
                        }
                    }
                    self._anvil.updateContent(self, self._anvil.element[0]);
                } else {
                    slot = self._anvil.childLayoutProps[pyChild._anvil.componentSpec.name].slot;
                }

                
                var ps = {  slot };
                if (props.width && !$el.hasClass('anvil-inlinable')) {
                    $el.parent().css("width", props.width);
                    ps.width = +props.width;
                }


                return {[pyChild._anvil?.componentSpec?.name]: ps};
            };

            self._anvil.getHandles = function(pyChild) {
                if (isInvisibleComponent(pyChild)) return [];

                const el = pyChild?.anvil$hooks.domElement
                if (el && !el.classList.contains('anvil-inlinable')) {
                    // Get layout handles for pyChild
                    var e = $(el);
                    var offset = e.offset();
                    var w = e.outerWidth();
                    var h = e.outerHeight();

                    return [{
                        x: offset.left + w,
                        y: offset.top + h/2 - 5,
                        width: 10,
                        height: 10,
                        cursor: "ew",
                        childName: pyChild._anvil?.componentSpec?.name,
                        owner: self._anvil.componentSpec?.name,
                    }];
                }
                return [];
            }

            self._anvil.handleGrab = function(handle, mouseX, mouseY) {
                // This is a layout handle for one of our children
                const $el = $(handle.pyChild.anvil$hooks.domElement);
                const originalWidthProp = parseFloat(handle.pyChild._anvil?.componentSpec?.layout_properties?.width ?? $el.outerWidth());
                return {
                    mouseX: mouseX,
                    originalHandleX: handle.x,
                    originalWidth: $el.parent().width(),
                    originalEltWidth: $el.width(),
                    originalWidthProp,
                };
            };

            self._anvil.handleDrag = function(handle, grab, mouseX, mouseY) {
                // This is a layout handle for one of our children
                var totalDx = mouseX - grab.mouseX;
                handle.x = grab.originalHandleX + totalDx;
                // NB we drag the component, not its inline container,
                // which avoids nasty reflows during resize
                const $el = $(handle.pyChild.anvil$hooks.domElement);
                $el.width(grab.originalEltWidth + totalDx);
                return handle;
            }

            // TODO: There is a bug in here (and in DesignFlowPanel) which means the width ends 
            // up wrong if you have previously set it by typing in the property table. Work out 
            // what that is and fix it.
            self._anvil.handleDrop = function(handle, grab, mouseX, mouseY) {
                var totalDx = mouseX - grab.mouseX;
                var newWidth = grab.originalWidthProp+totalDx;

                const $el = $(handle.pyChild.anvil$hooks.domElement);
                $el.css("width", "");
                $el.parent().css("width", newWidth)

                var r = { layoutProperties: {}};
                r.layoutProperties[handle.pyChild._anvil?.componentSpec?.name] = {
                    width: newWidth,
                };

                return r;
            }
        });
    }, "DesignRichText", [pyModule["RichText"]]);

    const oldContentSet = pyModule["RichText"].prototype._anvilClassic$propMap.content.set;

    const getPlaceholderElement = () => $('<span class="anvil-designer-empty-component-message">');

    function updateDesignName(s) {
        const contentProp = s._anvil.getPropJS("content");
        const e = s._anvil.element;
        const placeholderElement = s._anvil.placeholderElement.remove();
        if (!contentProp && (!s._anvil.components || !s._anvil.components.length)) {
            e.append(placeholderElement.text(s._anvil.designName));
            /*e.first().css('display', 'inline-block');*/
        }
    }

    pyModule["DesignRichText"].prototype._anvilClassic$propMap["content"].set = function(s,e,v) {
        s._anvil.placeholderElement || (s._anvil.placeholderElement = getPlaceholderElement());
        oldContentSet(s,e,v);
        updateDesignName(s);
    };

};
